var _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgValueIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_14",
    "data-name": "Group 14",
    xmlns: "http://www.w3.org/2000/svg",
    width: 79.592,
    height: 87.536,
    viewBox: "0 0 79.592 87.536",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9",
    "data-name": "Group 9",
    transform: "translate(0 52.972)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_28",
    "data-name": "Path 28",
    d: "M4942.5,1482.128a6.43,6.43,0,0,1-1.846-.271l-10.389-3.12a1.359,1.359,0,1,1,.782-2.6l10.389,3.119a3.4,3.4,0,0,0,3.875-1.318,2.188,2.188,0,0,0,.2-1.834,2.792,2.792,0,0,0-1.594-1.628l-20.923-7.015c-.03-.01-.059-.021-.089-.033a3.652,3.652,0,0,0-3.354.309c-.026.018-.056.036-.084.052l-12.443,7.108a1.359,1.359,0,1,1-1.348-2.361l12.4-7.085a6.356,6.356,0,0,1,5.822-.555l20.929,7.017.088.033a5.52,5.52,0,0,1,3.172,3.292,4.874,4.874,0,0,1-.437,4.075A5.947,5.947,0,0,1,4942.5,1482.128Z",
    transform: "translate(-4891.054 -1464.434)",
    fill: "#525252"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29",
    "data-name": "Path 29",
    d: "M5031.649,1565.748a6.088,6.088,0,0,1-1.716-.248l-20.446-6.021a3.277,3.277,0,0,0-3.195.769,1.361,1.361,0,0,1-.961.406l-.442,0h-.009a1.359,1.359,0,0,1-.087-2.716,6.022,6.022,0,0,1,5.462-1.071l20.447,6.021a3.339,3.339,0,0,0,2.657-.342l25.483-15.7a2.464,2.464,0,0,0,1.2-1.688,2.145,2.145,0,0,0-.5-1.735,3.228,3.228,0,0,0-4.028-.559l-13.061,8.317a1.359,1.359,0,1,1-1.46-2.293l13.073-8.325.022-.014a6.026,6.026,0,0,1,4-.8,5.648,5.648,0,0,1,3.542,1.933,4.821,4.821,0,0,1,1.1,3.915,5.205,5.205,0,0,1-2.455,3.567l-25.483,15.7A5.98,5.98,0,0,1,5031.649,1565.748Z",
    transform: "translate(-4983.194 -1534.806)",
    fill: "#525252"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30",
    "data-name": "Path 30",
    d: "M4702.259,1582.842a1.359,1.359,0,0,1-1.211-.739l-10.8-21.036a1.359,1.359,0,0,1,.641-1.855l10.843-4.995a1.36,1.36,0,0,1,1.774.606l10.748,20.6a1.359,1.359,0,0,1-.594,1.843l-10.8,5.434A1.351,1.351,0,0,1,4702.259,1582.842Zm-8.94-21.754,9.532,18.574,8.358-4.207-9.511-18.226Z",
    transform: "translate(-4690.103 -1548.278)",
    fill: "#525252"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_8",
    "data-name": "Ellipse 8",
    cx: 1.686,
    cy: 1.631,
    rx: 1.686,
    ry: 1.631,
    transform: "translate(13.075 24.053)",
    fill: "#525252"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_13",
    "data-name": "Group 13",
    transform: "translate(23.294 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10",
    "data-name": "Group 10",
    transform: "translate(6.634)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_1",
    "data-name": "Line 1",
    x2: 6.76,
    y2: 6.76,
    transform: "translate(1.298 1.298)",
    fill: "#525252"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31",
    "data-name": "Path 31",
    d: "M5159.646,656.957a1.3,1.3,0,0,1-.918-.38l-6.76-6.76a1.3,1.3,0,0,1,1.836-1.836l6.759,6.76a1.3,1.3,0,0,1-.917,2.217Z",
    transform: "translate(-5151.587 -647.6)",
    fill: "#525252"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11",
    "data-name": "Group 11",
    transform: "translate(39.17)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_2",
    "data-name": "Line 2",
    x1: 6.76,
    y2: 6.76,
    transform: "translate(1.298 1.298)",
    fill: "#525252"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32",
    "data-name": "Path 32",
    d: "M5654.6,656.957a1.3,1.3,0,0,1-.917-2.217l6.759-6.76a1.3,1.3,0,0,1,1.836,1.836l-6.76,6.76A1.294,1.294,0,0,1,5654.6,656.957Z",
    transform: "translate(-5653.3 -647.6)",
    fill: "#525252"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_33",
    "data-name": "Path 33",
    d: "M5753.842,1118.041a1.289,1.289,0,0,1-.739-.232l-7.757-5.386a1.3,1.3,0,1,1,1.481-2.133l7.757,5.386a1.3,1.3,0,0,1-.742,2.365Z",
    transform: "translate(-5699.685 -1080.067)",
    fill: "#525252"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34",
    "data-name": "Path 34",
    d: "M5050.6,1118.042a1.3,1.3,0,0,1-.741-2.365l7.758-5.386a1.3,1.3,0,0,1,1.48,2.133l-7.757,5.386A1.3,1.3,0,0,1,5050.6,1118.042Z",
    transform: "translate(-5049.296 -1080.068)",
    fill: "#525252"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35",
    "data-name": "Path 35",
    d: "M5458.473,1309.969a1.3,1.3,0,0,1-1.3-1.3v-8.8a1.3,1.3,0,1,1,2.6,0v8.8A1.3,1.3,0,0,1,5458.473,1309.969Z",
    transform: "translate(-5430.724 -1256.351)",
    fill: "#525252"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_12",
    "data-name": "Group 12",
    transform: "translate(5.245 1.473)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_36",
    "data-name": "Path 36",
    d: "M5172.05,691.028l5.439,11.02a1.246,1.246,0,0,0,.938.682l12.161,1.767a1.247,1.247,0,0,1,.691,2.127l-8.8,8.578a1.245,1.245,0,0,0-.358,1.1l2.077,12.112a1.247,1.247,0,0,1-1.809,1.314l-10.877-5.718a1.246,1.246,0,0,0-1.16,0l-10.876,5.718a1.247,1.247,0,0,1-1.81-1.314l2.077-12.112a1.244,1.244,0,0,0-.359-1.1l-8.8-8.578a1.247,1.247,0,0,1,.69-2.127l12.161-1.767a1.248,1.248,0,0,0,.939-.682l5.438-11.02A1.247,1.247,0,0,1,5172.05,691.028Z",
    transform: "translate(-5148.908 -689.034)",
    fill: "#4a8b2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37",
    "data-name": "Path 37",
    d: "M5140.161,712.452a2.552,2.552,0,0,1-2.506-2.978l2.073-12.085-8.78-8.559a2.545,2.545,0,0,1,1.41-4.341l12.135-1.763,5.427-11a2.545,2.545,0,0,1,4.564,0l5.426,11,12.134,1.763a2.545,2.545,0,0,1,1.411,4.341l-8.781,8.559,2.073,12.085a2.546,2.546,0,0,1-3.693,2.683l-10.853-5.706-10.853,5.706A2.546,2.546,0,0,1,5140.161,712.452Zm12.04-8.6a2.543,2.543,0,0,1,1.184.292l10.785,5.67-2.06-12.009a2.546,2.546,0,0,1,.732-2.253l8.725-8.5-12.057-1.752a2.545,2.545,0,0,1-1.917-1.392l-5.393-10.926-5.392,10.926a2.546,2.546,0,0,1-1.917,1.392l-12.056,1.752,8.724,8.5a2.543,2.543,0,0,1,.732,2.253l-2.059,12.009,10.784-5.67A2.546,2.546,0,0,1,5152.2,703.847Zm19.472-16.789h0Zm-19.519-14.181Z",
    transform: "translate(-5130.177 -670.311)",
    fill: "#525252"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgValueIcon);
export default __webpack_public_path__ + "static/media/value-icon.2ce7f5df413792d2aa67ca95f0a3d4c2.svg";
export { ForwardRef as ReactComponent };